import _toConsumableArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useEffect, useState } from 'react';
import { EuropeanUnionList, UKCountryList, useCountryStore } from '@jove-frontend/uikit';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { Box, Popover, Typography } from '@mui/material';
import clsx from 'clsx';
import { getCountryNormalLogoUrl } from 'libs/uikit/src/utils/country';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PriceComparisonSwitchCountryView = function PriceComparisonSwitchCountryView(props) {
  var valueChange = props.valueChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'normal' : _props$size,
      defaultCountry = props.defaultCountry,
      disableSwitchCountry = props.disableSwitchCountry,
      _props$allowSelectCou = props.allowSelectCountryList,
      allowSelectCountryList = _props$allowSelectCou === void 0 ? [].concat(_toConsumableArray(UKCountryList), _toConsumableArray(EuropeanUnionList)) : _props$allowSelectCou;

  var _useState = useState([]),
      selectCountryList = _useState[0],
      setSelectCountryList = _useState[1];

  var _useState2 = useState(null),
      selectedCountry = _useState2[0],
      setSelectedCountry = _useState2[1];

  var _useState3 = useState(null),
      anchorEl = _useState3[0],
      setAnchorEl = _useState3[1];

  var _useCountryStore = useCountryStore(),
      countries = _useCountryStore.state.countries,
      fetchCountries = _useCountryStore.actions.fetchCountries;
  /**
   * effects
   */


  useEffect(function () {
    fetchCountries();
  }, []);
  useEffect(function () {
    if (countries) {
      var list = [];
      allowSelectCountryList.forEach(function (code) {
        var item = countries.find(function (aItem) {
          return aItem['value'] === code;
        });

        if (item) {
          list.push(item);
        }
      });
      setSelectCountryList(list);
      var initialCountry = defaultCountry || 'GB';
      var item = list.find(function (aItem) {
        return aItem.value === initialCountry;
      });

      if (item) {
        setSelectedCountry(item);
      }
    }
  }, [countries, allowSelectCountryList]);

  var handleMenuOpen = function handleMenuOpen(event) {
    if (anchorEl) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  var handleMenuClose = function handleMenuClose() {
    setAnchorEl(null);
  };

  var selectCountryAction = function selectCountryAction(item) {
    setSelectedCountry(item);
    handleMenuClose();
    valueChange === null || valueChange === void 0 ? void 0 : valueChange(item === null || item === void 0 ? void 0 : item.value);
  };

  if ((selectCountryList === null || selectCountryList === void 0 ? void 0 : selectCountryList.length) === 0) {
    return null;
  }

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('z-10 flex min-h-10 cursor-pointer flex-row items-center'),
    onClick: handleMenuOpen,
    children: /*#__PURE__*/_jsxs(Box, {
      className: "mr-2 flex flex-1 flex-row items-center space-x-4",
      children: [/*#__PURE__*/_jsx("img", {
        loading: "lazy",
        className: "w-7",
        src: getCountryNormalLogoUrl(selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.value),
        alt: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.value
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-center space-x-1",
        children: [/*#__PURE__*/_jsxs(Box, {
          className: "flex flex-col",
          children: [/*#__PURE__*/_jsx(Typography, {
            className: clsx('text-[rgba(0, 0, 0, 0.7)] font-medium', size === 'small' ? 'text-[8px]' : 'text-[12px]'),
            children: "Country of your business"
          }), /*#__PURE__*/_jsx(Typography, {
            className: clsx('font-bold text-[#202020]', size === 'small' ? 'text-[10px]' : 'text-[16px]'),
            children: selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.label
          })]
        }), !disableSwitchCountry && /*#__PURE__*/_jsx(Box, {
          className: "ml-auto flex items-center",
          children: anchorEl ? /*#__PURE__*/_jsx(KeyboardArrowUpOutlined, {
            className: clsx('text-[#202020]', size === 'small' ? 'h-4 w-4' : 'h-6 w-6')
          }) : /*#__PURE__*/_jsx(KeyboardArrowDownOutlined, {
            className: clsx('text-[#202020]', size === 'small' ? 'h-4 w-4' : 'h-6 w-6')
          })
        })]
      }), /*#__PURE__*/_jsx(Popover, {
        open: Boolean(anchorEl),
        anchorEl: anchorEl,
        onClose: handleMenuClose,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        children: /*#__PURE__*/_jsx(Box, {
          className: "p-2",
          children: selectCountryList.map(function (item) {
            return /*#__PURE__*/_jsx(Box, {
              className: clsx('cursor-pointer px-4 py-2 hover:bg-gray-100', item.value === (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.value) && 'bg-blue-50'),
              onClick: function onClick() {
                return selectCountryAction(item);
              },
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "body2",
                children: item === null || item === void 0 ? void 0 : item.label
              })
            }, item.value);
          })
        })
      })]
    })
  });
};

export default PriceComparisonSwitchCountryView;